<script>
  import * as restfulService from '../../../services/restfulService'

  import helpers from '@mixins/helper'

  import NavigationButtons from './NavigationButtons'

  import bus from '@utils/bus'

  export default {
    mixins: [helpers],
    components: {NavigationButtons},
    name: 'pagamento',
    props: {
      dados: {
        required: true,
        type: Object,
        default: () => ({})
      },
      etapaAtiva: {
        type: Number,
        required: true
      },
      desabilita: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        pdfBase64: '',
        mostrarModalPdf: false,
        linhaDigitavel: '',
        refPedido: null,
        valorPedido: null,
        urlPagamento: '',
        mostrarModalPagarOnline: false,
        desativarPagamentoPrimeiroTitulo: false
      }
    },
    computed: {
      dadosMatricula: {
        get () {
          return this.dados
        }
      },
      isMobileSize: function () {
        return this.isMobile().any()
      },
      habilitarPagamentoOnline () {
        return this.dadosMatricula.matricula.titulo.podeAtivarPagamentoOnline
      }
    },
    methods: {
      fechar () {
        this.$emit('update:mostrarModal', false)
      },
      voltar () {
        this.desabilita.aba5 = false
        this.desabilita.aba6 = true
        this.$emit('update:desabilita', this.desabilita)
      },
      imprimirBoleto () {
        bus.$emit('show-loader')
        restfulService.get('boleto', 'pdf', this.dadosMatricula.matricula.titulo.codigo)
          .then((response) => {
            this.pdfBase64 = 'data:application/pdf;base64,' + response.base64
            this.mostrarModalPdf = true
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      gerarLinkPagamento () {
        bus.$emit('show-loader', {message: 'Gerando pedido de pagamento, aguarde...'})

        restfulService.get('titulo', 'gerar-link-pagamento', this.dadosMatricula.matricula.titulo.codigo)
          .then((response) => {
            bus.$emit('hide-loader')

            this.refPedido = response.id
            this.valorPedido = response.valor
            this.urlPagamento = response.url_pagamento

            this.mostrarModalPagarOnline = true
            window.open(this.urlPagamento, '_blank')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <v-container fluid grid-list-md pa-0>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card flat color="grey lighten-4" v-if="desativarPagamentoPrimeiroTitulo">
                    <v-card-text>
                        <div class="headline text-xs-center">
                          <div class="pa-4">
                            Caro aluno, você acabou de realizar a sua pré-matrícula, para aproveitar o
                            <strong>período promocional SEM REAJUSTE e com parcelamento diferenciado</strong>,
                            entre em contato pelo WhatsApp (53) 3242-8244 e solicite o primeiro boleto,
                            lembrando que o primeiro boleto é o que confirma a matrícula,
                            entre em contato e solicite o seu.
                          </div>
                        </div>
                    </v-card-text>
                </v-card>
                <v-card flat color="grey lighten-4" v-if="!desativarPagamentoPrimeiroTitulo">
                    <v-card-text v-if="dadosMatricula.matricula.titulo && !dadosMatricula.matricula.titulo.ocultarTitulo">
                        <h4 class="title mb-2">Linha digitável:</h4>
                        <div class="headline text-center" v-if="dadosMatricula.matricula.titulo">
                          <div class="linha-ditavel" v-if="dadosMatricula.matricula.titulo.linhaDigitavel">{{dadosMatricula.matricula.titulo.linhaDigitavel}}</div>
                        </div>
                        <v-divider class="mt-4 mb-4"></v-divider>
                        <div class="formas-pagamento d-flex">
                            <div>
                                <v-btn
                                  color="primary"
                                  large
                                  @click="imprimirBoleto()">
                                  <i class="fas fa-print"></i>
                                  <span class="pl-1">Imprima seu boleto aqui</span>
                                </v-btn>
                            </div>
                            <div class="text-xs-right">
                                <v-btn
                                  color="primary"
                                  large
                                  @click="gerarLinkPagamento()"
                                  v-if="habilitarPagamentoOnline">
                                  <i class="fas fa-credit-card"></i>
                                  <span class="pl-1">Pague online aqui</span>
                                </v-btn>
                            </div>
                        </div>
                        <v-divider class="mt-4 mb-4"></v-divider>
                        * O boleto também encontra-se disponível na seção "Financeiro - Minhas Cobranças" do menu à esquerda.<br>
                        ** O boleto leva algum tempo para ser registrado no banco. Caso não consiga efetuar o pagamento, tente novamente mais tarde.<br>
                        *** Caso não abra a janela ao clicar em pagar online, verifique no seu navegador se ele não está bloqueando popups.<br>
                    </v-card-text>
                    <v-card-text v-if="dadosMatricula.matricula.titulo && dadosMatricula.matricula.titulo.ocultarTitulo">
                        <div class="headline text-xs-center">
                          <div class="pa-4">
                            Acesse a seção <strong>Financeiro - Minhas Cobranças</strong> no menu a esquerda ou <router-link to="/financeiro/minhas-cobrancas">clique aqui</router-link> para visualizar,
                            emitir e/ou pagar online seus boletos de matrícula.
                          </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <div class="flex-header">
          <navigation-buttons
            :show-previous="false"
            :show-next="false"
            :next-click="fechar"
            :disable-next="false"
            :close="true"
          >
          </navigation-buttons>
        </div>
        <v-dialog v-model="mostrarModalPdf" width="80%">
            <v-card class="modal-pdf">
                <v-card-text>
                    <iframe :src="pdfBase64"></iframe>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="mostrarModalPdf = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
      <v-dialog v-model="mostrarModalPagarOnline" :width="isMobileSize ? '90%' : '50%'">
        <v-card>
          <v-container>
            <h3 class="pb-3" :class="{'display-1': !isMobileSize}">
              Pagamento online
            </h3>
            <div :class="{'body-1': isMobileSize, 'subheading': !isMobileSize}">
              <p>
                O pedido nº <strong>{{refPedido}}</strong> no valor de
                <strong>R$ {{valorPedido | currencyEnToBr}}</strong> foi gerado com sucesso. Caso não tenha aberto uma
                janela no seu navegador, clique no link abaixo para efetuar o pagamento.
              </p>
              <div class="text-xs-center">
                <strong>Link para pagamento:</strong><br>
                <a :href="urlPagamento" target="_blank">{{ urlPagamento }}</a>
              </div>
            </div>
          </v-container>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="mostrarModalPagarOnline = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
</template>
<style scoped lang="scss">
 .linha-ditavel {
    text-align: center;
  }
 @media all and (max-width: 800px) {
  .linha-ditavel {
    font-size: 16px;
    text-align: center;
  }

  .formas-pagamento {
    flex-direction: column;

    > div {
      width: 100%;

      > .v-btn {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Pagamento.vue?3d1ff08e